module.exports = __webpack_public_path__ + "img/logo-hauseful-type-dark.8d7f999a.svg";